import {CommonMessages} from '../common.messages';

export const FundOrderMessages = {
    GetProductPricesFailed: {
        key: 'GetProductPricesFailed',
        message: 'Could not get product prices.'
    },
    BuildOrderModelFailed: {
        key: 'BuildOrderModelFailed',
        message: 'Could not build the order model.'
    },
    OrderCreateFailed: {
        key: 'OrderCreateFailed',
        message: 'Create order failed.'
    },
    FundOrderBuyAmountInsufficientText: {
        key: 'FundOrderBuyAmountInsufficientText',
        message: 'Insufficient funds.'
    },
    InvalidAmount: {
        key: 'InvalidAmount',
        message: 'Amount should be greater than 0.'
    },
    InvalidNumberOfUnits: {
        key: 'InvalidNumberOfUnits',
        message: 'Number Of Units should be greater than 0.'
    },
    InvalidNumberOfSharesUnits: {
        key: 'InvalidNumberOfSharesUnits',
        message: 'Number Of <<ref>> should be greater than 0.'
    },
    FundOrderBuyProductPriceBoxText: {
        key: 'FundOrderBuyProductPriceBoxText',
        message: `Products's PURCHASE price`
    },
    FundOrderBuyProductPriceBoxNoIssuePriceText: {
        key: 'FundOrderBuyProductPriceBoxNoIssuePriceText',
        message: 'Products status/price mismatch. No "Issue price" available for this product.'
    },
    FundOrderBuyProductPriceBoxOnlyIssuePriceText: {
        key: 'FundOrderBuyProductPriceBoxOnlyIssuePriceText',
        message: 'Products status/price mismatch. Only "Issue price" available for this product.'
    },
    FundOrderBuyProductPriceBoxNoPricesText: {
        key: 'FundOrderBuyProductPriceBoxNoPricesText',
        message: 'No prices are available for this product.'
    },
    FundOrderSellQuantityInsufficientAccountSubTypeMutualFundText: {
        key: 'FundOrderSellQuantityInsufficientAccountSubTypeMutualFundText',
        message: 'Insufficient number of shares.'
    },
    FundOrderSellQuantityInsufficientAccountSubTypeInstrumentCertificateText: {
        key: 'FundOrderSellQuantityInsufficientAccountSubTypeInstrumentCertificateText',
        message: 'Insufficient number of units.'
    },
    FundOrderSellProductPriceBoxText: {
        key: 'FundOrderSellProductPriceBoxText',
        message: `Product's SELL price`
    },
    FundOrderSellProductPriceBoxNoPricesText: {
        key: 'FundOrderSellProductPriceBoxNoPricesText',
        message: 'No prices are available for this product.'
    },

    ...CommonMessages
};
